import script from "./StartEnd.vue?vue&type=script&setup=true&lang=js"
export * from "./StartEnd.vue?vue&type=script&setup=true&lang=js"

import "./StartEnd.vue?vue&type=style&index=0&id=7c90f92e&lang=css"

const __exports__ = script;

export default __exports__